namespace $.$$ {

	export class $shm_hitalama_resilience_page extends $.$shm_hitalama_resilience_page {

		retry_controls(): readonly $mol_view[] {
			return this.retry_visible() ? [ this.Retry() ] : []
		}

		@ $mol_action
		retry( event?: Event | null ) {
			if( event ) this.$.$mol_dom_context.location.reload()
			return event ?? null
		}

	}

}
